import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { TitleLocalizePipe } from '@usheru-hff/ui/pipes';

import { FestivalItemComponent } from './showtime-streaming-at-festivals/festival-item/festival-item.component';
import { ShowtimeStreamingAtFestivalsComponent } from './showtime-streaming-at-festivals/showtime-streaming-at-festivals.component';

@NgModule({
  imports: [CommonModule, FontAwesomeModule, TitleLocalizePipe],
  declarations: [FestivalItemComponent, ShowtimeStreamingAtFestivalsComponent],
  exports: [ShowtimeStreamingAtFestivalsComponent]
})
export class MovieDetailFeatureAtFestivalsModule {}
